import api from './api.service';
import { AxiosResponse } from 'axios';

class EventService {
  static getAllEvents = (): Promise<AxiosResponse<any>> => {
    return api.get("events");
  }
}

export default EventService;